














































































































import {Component, Vue} from 'vue-property-decorator';
import Cpaas from "@/consoleapi/api/cpaas";
import RestcommApplications from "@/consoleapi/api/restcomm/applications";
import CreateApplication from "@/components/applications/CreateApplication.vue";

@Component({
  components: {CreateApplication}
})
export default class ApplicationList extends Vue {
  private applications = {};

  private closeModal = "close";

  private showModal = "open";

  private urlBaseModal = "url-base";

  private rvdBaseModal = "rvd-base";

  private createModal = "close";

  private applicationName = '';

  private rcmlUrl = '';

  showCreateModal() {
    this.createModal = this.showModal;
  }

  showCreateUrlBaseModal() {
    this.createModal = this.urlBaseModal;
  }

  showCreateRVDBaseModal() {
    this.createModal = this.rvdBaseModal;
  }

  closeCreateModal() {
    this.createModal = this.closeModal;
  }

  createApplication() {
    if (this.applicationName.length < 1) {
      return;
    }
    const applications = new RestcommApplications();
    applications.setBearerToken(this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)));
    applications.create(this.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID)), this.applicationName, this.rcmlUrl)
        .then(response => {
          console.log(response.data);
          this.applicationName = '';
          this.rcmlUrl = '';
          this.closeCreateModal();
          this.getApplications();
        })
        .catch(error => {
          console.log(error.response);
        });
  }

  createRVDApplication(){
    if (this.applicationName.length < 1) {
      return;
    }
    const applications = new RestcommApplications();
    applications.setBearerToken(this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)));
    applications.createRVD(this.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID)), this.applicationName)
        .then(response => {
          console.log(response.data);
          this.applicationName = '';
          this.rcmlUrl = '';
          this.closeCreateModal();
          this.getApplications();
        })
        .catch(error => {
          console.log(error.response);
        });
  }

  getApplications() {
    const applications = new RestcommApplications();
    applications.setBearerToken(this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)));
    applications.get(this.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID)))
        .then(response => {
          console.log(response.data);
          this.applications = response.data;
        })
        .catch(error => {
          console.log(error.response);
        });
  }

  mounted() {
    this.getApplications();
  }
}
